import request from '../../../api/api';
import {ACT_ACTION} from './types';

export default function () {
    return dispatch => {
        return request('/v1/fin/get_sales_directions').then(
            data => {
                dispatch({
                    type: ACT_ACTION,
                    payload: data.data,
                });
            }
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/modules/finance/actions/LoadSaleDirections.js
 **/